module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Image-b6b18eaf09c36ea06f51f601e6245ed848d6648eaf6fdaaf84ca8fc1986e026e.svg";